// src/stable/useEnterDoneEffect.ts
import { useEffect } from "react";
import { useActivity } from "../__internal__/activity/useActivity.mjs";
import { noop } from "../__internal__/utils/index.mjs";
var useEnterDoneEffect = (effect, deps = []) => {
  const { isTop, transitionState } = useActivity();
  useEffect(() => {
    if (isTop && transitionState === "enter-done") {
      return effect();
    }
    return noop;
  }, [isTop, transitionState, ...deps]);
};
export {
  useEnterDoneEffect
};
